import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL + '/api' || 'http://localhost:3001/api';
const token = localStorage.getItem("token");

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add token to requests
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        console.log('Making request to:', config.url); // Debug log
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => {
        console.log('Response from:', response.config.url, response.status); // Debug log
        return response;
    },
    (error) => {
        console.error('API Error:', error.response?.status, error.response?.data);
        if (error.response) {
            return Promise.reject(error.response.data);
        } else if (error.request) {
            return Promise.reject({
                message: 'Server is not responding'
            });
        } else {
            return Promise.reject({
                message: error.message
            });
        }
    }
);

export const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    console.log('Uploading file to /upload/mpesa'); // Debug log

    const response = await api.post('/upload/mpesa', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            console.log(`Upload progress: ${percentCompleted}%`);
        },
    });

    return response.data;
};

export const uploadBankStatement = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    console.log('Uploading file to /upload/bank'); // Debug log

    const response = await api.post('/upload/bank', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            console.log(`Upload progress: ${percentCompleted}%`);
        },
    });

    return response.data;
};

export const uploadAutoDetect = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
    });

    return response.data;
};

export const getTransactions = async (params = {}) => {
    const response = await api.get('/transactions', {
        params
    });
    return response.data;
};

export const getTransaction = async (id) => {
    const response = await api.get(`/transactions/${id}`);
    return response.data;
};

export const updateTransaction = async (id, data) => {
    const response = await api.put(`/transactions/${id}`, data);
    return response.data;
};

export const deleteTransaction = async (id) => {
    const response = await api.delete(`/transactions/${id}`);
    return response.data;
};

export const getSummary = async () => {
    const response = await api.get('/summary');
    return response.data;
};


export const checkHealth = async () => {
    const response = await axios.get(`${API_BASE_URL.replace('/api', '')}/health`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });
    return response.data;
};